const React = require("react");

function CheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 13l4 4L19 7"
  }));
}

module.exports = CheckIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/CheckIcon.js
 ** module id = 470
 ** module chunks = 0
 **/